import PropTypes from 'prop-types'
import { Table, Tbody, Thead, Tr } from '@chakra-ui/react'
import { numberFormatter } from 'lib'
import { ThMetric, TdMetric } from './common'

export const MetricsInstallation = ({ data }) => {
  return (
    <Table>
      <Thead>
        <Tr>
          <ThMetric w="7%">Department</ThMetric>
          <ThMetric w="7%">Sub Department</ThMetric>
          <ThMetric w="10%">Measure</ThMetric>
          <ThMetric w="10%">Unit of Measure</ThMetric>
          {data.dateHeaders.map(dateHeader => <ThMetric key={dateHeader.date}>{dateHeader.text}</ThMetric>)}
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <TdMetric rowSpan={17}>Installation</TdMetric>
          <TdMetric rowSpan={4}>Overall</TdMetric>
          <TdMetric rowSpan={2}>Total</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.installation.overall.total.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.installation.overall.total.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>New Last 7 Days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.installation.overall.new.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.installation.overall.new.amount)}</TdMetric>)}
        </Tr>
        {/* Installation - Prep and Site Work */}
        <Tr>
          <TdMetric rowSpan={3}>Prep and Site Work</TdMetric>
          {/* <TdMetric>{'Projects Delivered, but no installation Scheduled >3 days'}</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.installation.prepSiteWork.noInstallation.count}</TdMetric>)} */}
        </Tr>
        <Tr>
          <TdMetric>Installs Scheduled</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.installation.prepSiteWork.installScheduled.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Installation Complete Last 7 days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.installation.prepSiteWork.installCompleted.count}</TdMetric>)}
        </Tr>
        {/* Installation - Post Installation */}
        <Tr>
          <TdMetric rowSpan={7}>Post Installation</TdMetric>
          {/* <TdMetric rowSpan={2}>Total</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.postinstallation.total.count}</TdMetric>)} */}
        </Tr>
        {/* <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.postinstallation.total.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>New Last 7 Days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.postinstallation.new.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.postinstallation.new.amount)}</TdMetric>)}
        </Tr> */}
        <Tr>
          <TdMetric>Pending Resolution</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.postinstallation.pendingResolution.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>Pending Resolution Avg # of Days</TdMetric>
          <TdMetric>Avg</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.postinstallation.pendingDays.avg}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Median</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.postinstallation.pendingDays.median}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Projects Closed-out</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.postinstallation.closedOut.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>Projects Closed-out # of days</TdMetric>
          <TdMetric>Avg</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.postinstallation.closedOutDays.avg}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Median</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.postinstallation.closedOutDays.median}</TdMetric>)}
        </Tr>
      </Tbody>
    </Table>
  )
}

MetricsInstallation.propTypes = {
  data: PropTypes.object
}
